<template>
    <b-container fluid class="mt--7">
        <export-details-dialog :query-data="query" ref="detailsDialog" />

        <b-card>
            <b-card-header>
                <b-row>
                    <b-col cols="6">
                        <b-form-input
                            type="text"
                            placeholder="Filter..."
                            addon-right-icon="ni ni-zoom-split-in"
                            v-model="query"
                            @input="updateQuery"
                        ></b-form-input>
                    </b-col>

                    <b-col cols="6">
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>

            <b-card-body>
                <p class="mt-3">
                    Page: {{ pagination.page }} of {{ pageCount }} Total:
                    {{ pagination.total }}
                </p>

                <b-table
                    id="customerTable"
                    :items="customers"
                    :fields="fields"
                    small
                    responsive
                >
                    <template #cell(id)="row">
                        <b-button
                            size="sm"
                            @click="view(row.item.id)"
                            class="mr-2"
                            variant="primary"
                            v-show="user_permissions.includes('view.customers')"
                        >
                            View
                        </b-button>
                    </template>
                </b-table>

                <b-row>
                    <b-col>
                        <b-pagination
                            class="float-right"
                            v-model="pagination.page"
                            :total-rows="pagination.total"
                            :per-page="pagination.pageSize"
                            aria-controls="customerTable"
                            pills
                            align="right"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-container>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import ExportDetailsDialog from './ExportDetailsDialog'

//import autoTable from 'jspdf-autotable'
export default {
    name: 'customer-table',
    components: {
        ExportDetailsDialog,
    },
    mixins: [popupMixins],
    props: ['type', 'title'],
    data() {
        return {
            query: '',
            page: 1,
            template: false,
            //user_permissions: [],
            fields: [
                { label: 'Actions', key: 'id' },
                'code',
                'name',
                'phone',
                'email',
            ],
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
    },
    methods: {
        showDetailsDialog() {
            this.$refs.detailsDialog.show(this.queryModel)
        },
        updateQuery: _.debounce(function (query) {
            this.query = query
            this.$router.push({ query: { query: this.query } })
            this.doSearch()
        }, 200),
        changePage: function (page) {
            this.page = page
            this.$router.push({ query: { page: page } })
            this.doSearch()
        },
        doSearch() {
            const { query, page } = this
            this.$store.dispatch('customers/fetch', {
                query,
                page,
            })
        },
        view(index) {
            const path = `${this.$route.path}/${index}`
            this.$router.push({ path })
        },
        deleteItem(id) {
            let item = this.customers.find(el => el.id == id)

            const title = 'Delete Customer?'
            const message = `Are you sure you want to delete customer.. ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('customers/delete', id)
                        .then(() => {
                            this.doToast(
                                'Deleted!',
                                'Customer has been deleted.',
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                'Error!',
                                'Unable to delete Customer!',
                                'danger'
                            )
                        })
                }
            })
        },
    },

    computed: {
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        customers() {
            return this.$store.getters['customers/customers']
        },
        pagination() {
            return this.$store.state.customers.pagination || {}
        },
        user() {
            return this.$store.state.user
        },

        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
}
</script>
<style></style>
